import { Calendar, FileText, QrCode, Settings } from 'lucide-react';
import type { PillTab } from '@/components/common/PillTabs';

export type ShiftSectionId = 'planning' | 'templates' | 'qr-stations' | 'settings';

export interface ShiftSection extends PillTab<ShiftSectionId> {
  permission: string;
}

/** Sotto-sezioni di "Pianificazione Turni"; ognuna resta gated dal proprio permesso. */
export const SHIFT_SECTIONS: ReadonlyArray<ShiftSection> = [
  { key: 'planning', label: 'Pianificazione', icon: Calendar, permission: 'hr.shifts.view' },
  { key: 'templates', label: 'Template turni', icon: FileText, permission: 'hr.templates.manage' },
  { key: 'qr-stations', label: 'QR Sedi', icon: QrCode, permission: 'hr.qr.manage' },
  { key: 'settings', label: 'Impostazioni', icon: Settings, permission: 'hr.settings.manage' },
];

/** Parametro URL della sotto-sezione (deep-link e refresh). */
export const SHIFT_SECTION_PARAM = 'section';

/** Vecchi id di tab principale (prima erano tab a sé) → sotto-sezione. */
export const LEGACY_TAB_TO_SECTION: Readonly<Record<string, ShiftSectionId>> = {
  shifts: 'planning',
  templates: 'templates',
  'qr-stations': 'qr-stations',
  settings: 'settings',
};

export function isShiftSectionId(value: string | null): value is ShiftSectionId {
  return value !== null && SHIFT_SECTIONS.some((s) => s.key === value);
}
